
export default function (router, ability) {
    router.beforeEach((to, from, next) => {
        if (!to?.meta?.permission) {
            return next();
        }
        if (ability.can(to?.meta?.permission.action, to?.meta?.permission.subject)) {
            return next();
        }
        return next({ name: 'home' });
    });
}
